import { DateHelpers } from '@headless-workspace/utils';
import { HTMLString } from '../../HTMLString';
import { PersistentBannerSlotDTO } from './PersistentBannerSlotDTO';

export const DEFAULT_BG_COLOR = '';

export type PersistentBannerSlotValue = Readonly<{
    id: string;
    text: HTMLString;
    backgroundColor: string;
    linkLabel?: string;
    href?: string;
    endOfCountDownDateISO: string | null;
}>;

export const mapPersistentBannerSlot = (dto: PersistentBannerSlotDTO): PersistentBannerSlotValue | undefined => {
    if (!dto.details.cta?.label && !dto.details.subTitle) {
        return;
    }

    return {
        id: dto.id,
        text: HTMLString(dto.details.subTitle ?? ''),
        backgroundColor: dto.details.backgroundColor ?? DEFAULT_BG_COLOR,
        linkLabel: dto.details.cta?.label,
        href: dto.details.cta?.link,
        endOfCountDownDateISO: dto.details.endOfCountDown
            ? DateHelpers.formatToISODate(dto.details.endOfCountDown)
            : null,
    };
};
